import classNames from 'classnames';
import styles from './index.module.scss';

export default function YesNoSwitch ({
  checked,
  onChange,
  size = "medium" | "small" | "large",
  yesText = "Oui",
  noText = "Non",
  className = ""
}) {
  return(
    <div className={classNames({
      [styles.yes_no_switch]: true,
      [className]: true,
      [styles[`yes_no_switch_${size}`]]: true
    })}>
      <button
        className={`${styles.switch_button} ${checked ? styles.active_yes : styles.active_no}`}
        onClick={() => onChange(!checked)}
      >
        <span className={`${styles.option} ${checked ? styles.active_yes : ''}`}>
          {yesText}
        </span>
        <span className={`${styles.option} ${!checked ? styles.active_no : ''}`}>
          {noText}
        </span>
      </button>
    </div>
  );
}
